import { render, staticRenderFns } from "./ImageSliderWrap.vue?vue&type=template&id=27148484&scoped=true&lang=pug&"
import script from "./ImageSliderWrap.vue?vue&type=script&lang=js&"
export * from "./ImageSliderWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27148484",
  null
  
)

export default component.exports